"use client";
import React from "react";
import { useRouter } from "next/navigation";

import getFindQrHandler from "@api/getFindQr/index";

import TrackingScripts from "@/app/[lang]/p/[qrId]/TrackingScripts";

import { useApiWithLayout } from "@/hooks/api";
import { QRProps } from "@/contexts/QREditorContext/types";
import { QREditorAPItoDataConversor } from "@/services/ApiConversorService/QREditor";

import { QRCodeScanResponse } from "@/interface/api/getFindQr/types";

import { QRViewPageTemplate } from "@/templates/QRViewPageTemplate";

import { IQrViewPage } from "@/types/types";
import { Tracking } from "@/types/qr";

const NOT_FOUND_MESSAGE = "not found";

export const PViewContainer = (props: IQrViewPage) => {
  const [qrData, setQrData] = React.useState<QRProps<any> | undefined>(undefined);
  const [trackingIds, setTrackingIds] = React.useState<Tracking>(undefined);
  const router = useRouter();

  const {
    request: requestFind,
    data: dataFind,
    error: errorFind,
  } = useApiWithLayout(getFindQrHandler.getFindQr);

  const qrCodeId = props.params.qrId;

  React.useEffect(() => {
    qrCodeId && requestFind({ qrCodeId });
  }, [qrCodeId]);

  React.useEffect(() => {
    if (errorFind?.status === 400 || errorFind?.status === 404) {
      if (errorFind.data.message?.includes(NOT_FOUND_MESSAGE)) router.replace("/404");
    }
  }, [errorFind]);

  React.useEffect(() => {
    if (dataFind) {
      const dataQR: QRCodeScanResponse = dataFind.data;

      setQrData(QREditorAPItoDataConversor.getQRData(dataQR));
      setTrackingIds(dataQR?.content?.tracking || undefined);
    }
  }, [dataFind]);

  return (
    <>
      {trackingIds && <TrackingScripts trackingIds={trackingIds} />}
      <QRViewPageTemplate
        qrData={qrData}
        language={props.params.lang}
      />
    </>
  );
};
